module.exports = __webpack_public_path__ + "media/images/woods-4886c38607569b1c9e68d6b4242907c5.svg";